import { IDim1Option } from './9-to-12-options.constant';

export const Six_to_8_Options: IDim1Option[] = [
  {
    human: 'All students',
    key: 'ALL_MS_STUDENTS',
    schoolType: '6_to_8',
    schoolLevel: 'MS',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: null,
    dimension: 1,
    isActive: true,
    order: 0,
    isCalculatedGraphQuery: false,
    getGraphQuery: () => `isMS=true`,
    filterStudent: student => true,
  },
  {
    human: 'Grade',
    key: 'GRADE',
    schoolType: '6_to_8',
    schoolLevel: 'MS',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: 'studentDetails.grade',
    dimension: 1,
    isActive: false,
    order: 2,
    children: [],
  },
  {
    human: 'Official class',
    key: 'OFFICIAL_CLASS',
    schoolType: '6_to_8',
    schoolLevel: 'MS',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: 'studentDetails.officialClass',
    dimension: 1,
    isActive: false,
    order: 5,
    children: [],
  },
  {
    human: 'Special population',
    key: 'SPECIAL_POPULATION',
    schoolType: '6_to_8',
    schoolLevel: 'MS',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: ['spedDetails.isSped', 'ellDetails.isEll'],
    dimension: 1,
    isActive: false,
    order: 6,
    children: [],
  },
  {
    human: 'Attendance point person',
    key: 'ATTENDANCE_POINT_PERSON',
    schoolType: '6_to_8',
    schoolLevel: 'MS',
    lists: ['ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY'],
    path: 'pointPeople',
    optionType: 'user',
    optionFilter: { type: 'ATTENDANCE' },
    dimension: 1,
    isActive: false,
    order: 6,
    children: [],
  },
  {
    human: 'Academic point person',
    key: 'ACADEMIC_POINT_PERSON',
    schoolType: '6_to_8',
    schoolLevel: 'MS',
    lists: ['ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY'],
    path: 'pointPeople',
    optionType: 'user',
    optionFilter: { type: 'ACADEMIC' },
    dimension: 1,
    isActive: false,
    order: 7,
    children: [],
  },
  {
    human: 'Post-secondary point person',
    key: 'POST_SECONDARY_POINT_PERSON',
    schoolType: '6_to_8',
    schoolLevel: 'MS',
    lists: [],
    path: 'pointPeople',
    optionType: 'user',
    optionFilter: { type: 'POSTSECONDARY' },
    dimension: 1,
    isActive: false,
    order: 8,
    children: [],
  },
];
